var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 13.5,
    r: 11.5,
    fill: "#04C300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.106 9.21162C21.6112 8.55505 21.4708 7.63737 20.7924 7.1619C20.114 6.68644 19.1545 6.83325 18.6493 7.48981L12.1369 15.9536L9.85433 14.0408C9.21938 13.5087 8.24995 13.5715 7.68905 14.1812C7.12814 14.7909 7.18817 15.7164 7.82311 16.2485L11.277 19.143C11.3324 19.1966 11.393 19.2467 11.4585 19.2926C11.8717 19.5822 12.3891 19.6409 12.8446 19.4943C13.0968 19.4147 13.331 19.2717 13.5193 19.0671C13.5718 19.01 13.6189 18.9501 13.6606 18.888L21.106 9.21162Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/Tick Circle.f7ff488c360a366b6f6203122dc1a930.svg";
export { ForwardRef as ReactComponent };